import { DeviceDetectorService } from "ngx-device-detector";
import { BehaviorSubject, Observable } from "rxjs";

import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class EvaLayoutService {
  private IS_MENU_COLLAPSED_KEY = "isMenuCollapsed";

  // isMobile = mobile + tablet + desktop < 1000px
  private isMobileSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(window.innerWidth <= 1000);
  private isMenuCollapsedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private isMenuHoveredSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private isMobileMenuToggledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private collapseLockOwners = new Set<string>();
  private collapsedBeforeLock = false;

  windowWidth: number = window.innerWidth;

  constructor(private deviceService: DeviceDetectorService) {
    window.addEventListener("resize", this.onResize.bind(this));

    this.checkIsMobile();

    localStorage.getItem(this.IS_MENU_COLLAPSED_KEY) === "true"
      ? this.isMenuCollapsedSubject.next(true)
      : this.isMenuCollapsedSubject.next(false);
  }

  private onResize() {
    this.windowWidth = window.innerWidth;
    this.checkIsMobile();
  }

  private isMobile(): boolean {
    return !(this.deviceService.isDesktop() && this.windowWidth > 1000);
  }

  private checkIsMobile() {
    const isMobile = this.isMobile();
    if (this.isMobileSubject.value !== isMobile) {
      this.isMobileSubject.next(isMobile);
      this.isMobileMenuToggledSubject.next(false);
    }
  }

  get isMobile$(): Observable<boolean> {
    return this.isMobileSubject.asObservable();
  }

  get isMenuCollapsed$(): Observable<boolean> {
    return this.isMenuCollapsedSubject.asObservable();
  }

  toggleMenuCollapsed() {
    const next = !this.isMenuCollapsedSubject.value;
    if (!this.isCollapseLocked) localStorage.setItem(this.IS_MENU_COLLAPSED_KEY, JSON.stringify(next));
    this.isMenuCollapsedSubject.next(next);
  }

  setMenuCollapsed(collapsed: boolean) {
    localStorage.setItem(this.IS_MENU_COLLAPSED_KEY, JSON.stringify(collapsed));
    this.isMenuCollapsedSubject.next(collapsed);
  }

  get isCollapseLocked(): boolean {
    return this.collapseLockOwners.size > 0;
  }

  lockCollapsed(owner: string) {
    if (this.collapseLockOwners.has(owner)) return;
    if (!this.isCollapseLocked) {
      this.collapsedBeforeLock = this.isMenuCollapsedSubject.value;
    }
    this.collapseLockOwners.add(owner);
    this.isMenuCollapsedSubject.next(true);
  }

  unlockCollapsed(owner: string) {
    if (!this.collapseLockOwners.delete(owner) || this.isCollapseLocked) return;
    this.isMenuCollapsedSubject.next(this.collapsedBeforeLock);
  }

  toggleMenuHovered(value: boolean) {
    this.isMenuHoveredSubject.next(value);
  }

  get isMenuHovered$(): Observable<boolean> {
    return this.isMenuHoveredSubject.asObservable();
  }

  toggleMobileMenuToggled() {
    this.isMobileMenuToggledSubject.next(!this.isMobileMenuToggledSubject.value);
  }

  get isMobileMenuToggled$(): Observable<boolean> {
    return this.isMobileMenuToggledSubject.asObservable();
  }
}
